import React from 'react';
import Abnormality from './Abnormality';
import { handleMiscollectionValidations } from '../../../shared/utils/handleMiscollectionValidations';
import { I18N } from '../../../constants';

const miscollectionReasons = [
    {
        eventKey: 'Accident on the road',
        label: 'Accident on the road',
    },
    {
        eventKey: 'Collection data mismatch',
        label: 'Collection data mismatch',
    },
    {
        eventKey: 'Delay from previous supplier',
        label: 'Delay from previous supplier',
    },
    {
        eventKey: 'Delayed departure due to dock delay',
        label: 'Delayed departure due to dock delay',
    },
    {
        eventKey: 'Delayed departure due to stringing: previous loop delay',
        label: 'Delayed departure due to stringing: previous loop delay',
    },
    {
        eventKey: 'Equipment break down (Tractor/Trailer) or driver issue',
        label: 'Equipment break down (Tractor/Trailer) or driver issue',
    },
    {
        eventKey: 'Road blocked / diversion',
        label: 'Road blocked / diversion',
    },
    {
        eventKey: 'Other OEM collections at supplier',
        label: 'Other OEM collections at supplier',
    },
    {
        eventKey: 'Stopped by police',
        label: 'Stopped by police',
    },
    {
        eventKey: 'Supplier OWT',
        label: 'Supplier OWT',
    },
    {
        eventKey: 'Weather condition',
        label: 'Weather condition',
    },
    {
        eventKey: I18N.ABNORMALITY_LOCATION.OTHER,
        label: I18N.ABNORMALITY_LOCATION.OTHER,
    },
];

export default class Miscollection extends React.Component {
    render() {
        return (
            <Abnormality
                reasons={miscollectionReasons}
                validations={handleMiscollectionValidations}
                {...this.props}
            />
        );
    }
}
